// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_2vNgbyPLwgIh20D0XPG2wM"};